import "./InfoHubPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Image 2 Data
const enrichData = [
  {
    title: "MIND AND BODY",
    items: [
      "YOGA LESSONS",
      "OUT DOOR GAMES",
      "MY VILLAGE GAMES",
      "LUNCH BOX RECEPIES",
    ],
  },
  {
    title: "LEARN EASY",
    items: [
      "SCIENCE EXPERIMENTS",
      "LEARN PAPER CRAFTS",
      "ORIGAMI STEP-BY -STEP",
      "SIMPLE MEMORY TIPS",
      "MY HOBBY IDEAS",
    ],
  },
  {
    title: "PROJECT HELP",
    items: [
      "GROUP PROJECT IDEAS",
      "MAKE A FAMILY TREE",
      "DESIGN STATIONARY",
      "DECORATION IDEAS",
      "PROJECT RESOURCES",
    ],
  },
  {
    title: "PARTICIPATE & WIN",
    items: [
      "BE A YOUNG ACHIVER",
      "ESSEY WRITING RESOURCES",
      "INDIAN COMPETITIONS",
      "INTERNATIONAL COMPETITIONS",
    ],
  },
  {
    title: "EARLY CAREER",
    items: [
      "LEARN AI",
      "AI POWERED PROJECTS",
      "EARLY CAREER PROGRAMS",
      "COMPETITIVE EXAM RESOURCES",
    ],
  },
];

export default function EnrichPage() {
  return (
    <div className="enrichWrapper" style={{backgroundColor:"#cafff5"}}>
      {enrichData.map((section) => (
        <div className="enrichColumn" key={section.title}>
          <div className="enrichHeading">
            <span className="enrichTitle">{section.title}</span>
          </div>

          <ul className="enrichList">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="enrichArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}